"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ChangeCurrentPassword;
var _react = _interopRequireWildcard(require("react"));
var _awsAmplify = require("aws-amplify");
var _reactRouterDom = require("react-router-dom");
var _CurrentChangePasswordComponent = _interopRequireDefault(require("../components/CurrentChangePasswordComponent"));
var _helper = require("../common_features/utility/helper");
var _strings = require("../common_features/utility/strings");
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _images = _interopRequireDefault(require("../common_features/assets/images"));
var _Services = require("../common_features/utility/Services");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ChangeCurrentPassword(props) {
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [currentPassword, setCurrentPassword] = (0, _react.useState)(null);
  const [newPassword, setPassword] = (0, _react.useState)(null);
  const [confirmNewPassword, setConfirmPassword] = (0, _react.useState)(null);
  const [hasMinLength, setHasMinLength] = (0, _react.useState)(false);
  const [hasOneUpperLowerCase, sethasOneUpperLowerCase] = (0, _react.useState)(false);
  const [hasOneNumber, setHasOneNumber] = (0, _react.useState)(false);
  const [hasSpecialChar, setHasSpecialChar] = (0, _react.useState)(false);
  const [isConfirmPasswordTouch, setIsConfirmPasswordTouch] = (0, _react.useState)(false);
  const [isNewPasswordTouch, setIsNewPasswordTouch] = (0, _react.useState)(false);
  const [currentPasswordError, setCurrentPasswordError] = (0, _react.useState)();
  const [displayModal, setDisplayModal] = (0, _react.useState)(false);
  const navigate = (0, _reactRouterDom.useNavigate)();
  const successData = {
    variant: "password-change-modal",
    displayCrossIcon: false,
    modalHeaderTextStyle: {
      fontSize: 16,
      paddingBottom: 16,
      color: "#4F8309"
    },
    modalDetailText: "You have changed your password successfully",
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px"
    },
    positiveActionButtonTitle: "Continue",
    negativeButtonActionTitle: null,
    positiveAction: () => {
      setDisplayModal(false);
      handlePositiveAction();
    }
  };
  const handlePositiveAction = () => {
    navigate(_RoutePath.default.editProfile.useLink);
  };
  function validatePassword(e, handler) {
    const value = e.target.value;
    setHasMinLength(value.length > 7);
    sethasOneUpperLowerCase(/[a-z]/.test(value) && /[A-Z]/.test(value));
    setHasOneNumber(/\d/.test(value));
    setHasSpecialChar(_strings.VALIDATION_REGX.specialCharacter.test(value));
    (0, _helper.onChangeHandler)(e, handler);
  }
  function checkDisabled() {
    const passwordValid = hasMinLength && hasOneNumber && hasOneUpperLowerCase && hasSpecialChar;
    return currentPassword && passwordValid && newPassword === confirmNewPassword || false;
  }
  const handleConfirmPasswordChange = (e, state) => {
    setIsConfirmPasswordTouch(true);
    (0, _helper.onChangeHandler)(e, state);
  };
  const handleNewPasswordBlur = () => {
    setIsNewPasswordTouch(true);
  };
  const resetPassword = async () => {
    setIsLoading(true);
    await _awsAmplify.Auth.currentAuthenticatedUser().then(async user => {
      await _awsAmplify.Auth.changePassword(user, currentPassword, newPassword).then(async user => {
        setIsLoading(false);
        setDisplayModal(true);
        await (0, _Services.sendNotificationCall)();
      }).catch(e => {
        console.log(e);
        setIsLoading(false);
        setCurrentPasswordError(true);
      });
    }).catch(e => {
      console.log(e);
      setIsLoading(false);
    });
  };
  const handleBackEditProfile = () => {
    navigate(-1);
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_CurrentChangePasswordComponent.default, {
    headerText: "Change Password",
    leftArrow: _images.default.leftArrow.default,
    backNavigationScreen: "Edit Profile",
    handleBack: handleBackEditProfile,
    currentPassword: currentPassword,
    onChangeCurrentPassword: e => {
      (0, _helper.onChangeHandler)(e, setCurrentPassword);
    },
    newpasswordCCP: newPassword,
    onChangeNewPasswordCCP: e => {
      validatePassword(e, setPassword);
    },
    confirmNewPassword: confirmNewPassword,
    onChangeConfirmNewPassword: e => {
      handleConfirmPasswordChange(e, setConfirmPassword);
    },
    onClickContinue: resetPassword,
    isLoading: isLoading,
    hasMinLengthCCP: (0, _helper.getPasswordConditionCheckColor)(hasMinLength),
    hasOneNumber: (0, _helper.getPasswordConditionCheckColor)(hasOneNumber),
    hasOneUpperLowerCase: (0, _helper.getPasswordConditionCheckColor)(hasOneUpperLowerCase),
    hasSpecialChar: (0, _helper.getPasswordConditionCheckColor)(hasSpecialChar),
    isContinueDisabled: checkDisabled(),
    confirmPasswordText: "Current Password",
    passwordText: "New Password",
    currentPasswordPlaceholder: "Enter current password",
    newPasswordPlaceholderCCP: "Enter new password",
    validationTextt1: "At least 8 characters",
    validationTextt2: "1 uppercase and 1 lowercase letter",
    validationTextt3: "1 number",
    validationTextt4: "1 special character",
    confirmPassword: "Confirm New Password",
    confirmPasswordPlaceholder: "Confirm new password",
    buttonText: "Change Password",
    errorMessage: !(hasMinLength && hasOneNumber && hasOneUpperLowerCase && hasSpecialChar),
    conFirmErrorMessage: confirmNewPassword !== newPassword && isConfirmPasswordTouch,
    handleNewPasswordBlur: handleNewPasswordBlur,
    isNewPasswordTouch: isNewPasswordTouch,
    currentPasswordError: currentPasswordError,
    displayModalData: successData,
    displayModal: displayModal
  }));
}